import { LoadingOrb } from '@/components/ui/loading-orb'

/**
 * Full-screen loading indicator
 *
 * Shown while checking authentication status
 */
export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <LoadingOrb state="working" size={64} aria-hidden="true" className="mx-auto" />
        <p className="mt-4 text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  )
}

export default LoadingScreen


